
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVisibilityOnGoogle as ObiVisibilityOnGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-visibility-on-google.js';
 
 
 

 
 export const ObiVisibilityOnGoogle = createComponent({
   react: React,
   tagName: 'obi-visibility-on-google',
   elementClass: ObiVisibilityOnGoogleElement,
   events: {
     
   }
  });
 
 